import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { OrderProvider } from "./context/OrderContext";
import {
  ThemeProvider as ThemeChangeProvider,
  ThemeStateContext
} from "./context/ThemeContext";
import { CssBaseline } from "@material-ui/core";
import config from "./config";
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: config.cognito.userPoolId,
        userPoolClientId: config.cognito.userPoolClientId,
      },
    },
    API: {
      REST: {
        [config.apiName]: {
          endpoint: config.apiEndpoint,
          region: config.region,
        },
      },
    },
  },
  {
    API: {
      REST: {
        // Attaches the current user's ID token to every REST request, replacing v5's per-endpoint custom_header
        headers: async () => {
          try {
            const session = await fetchAuthSession();
            return { Authorization: session.tokens?.idToken?.toString() };
          } catch (error) {
            return {};
          }
        },
      },
    },
  }
);

ReactDOM.render(
  <LayoutProvider>
    <UserProvider>
        <ThemeChangeProvider>
          <ThemeStateContext.Consumer>
            {theme => (
              <ThemeProvider theme={theme}>
                <OrderProvider>
                <CssBaseline />
                <App />
                </OrderProvider>
              </ThemeProvider>
            )}
          </ThemeStateContext.Consumer>
        </ThemeChangeProvider>
    </UserProvider>
  </LayoutProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
